import React, { Component } from 'react';
import i18n from '../i18n';

export default function(basePath = '') {
  return function(WrappedComponent) {
    class LocalizedComponent extends Component {
      constructor(props) {
        super(props);

        //If we set both a basePath and an instance path, then combine the two.
        if(basePath && this.props.i18nPath) {
          this.i18n = i18n.scoped(basePath + '.' + this.props.i18nPath);
        } else {
          this.i18n = i18n.scoped(basePath || this.props.i18nPath);
        }
      }

      render() {
        return <WrappedComponent i18n={this.i18n} {...this.props} />;
      }
    }

    LocalizedComponent.displayName = `WithLocalization(${basePath})(${getDisplayName(WrappedComponent)})`;

    return LocalizedComponent;
  }
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}


// WEBPACK FOOTER //
// ./src/components/localize.js